import request from 'services/axios'

/**
 * Pending cashbox invitations (to me) + membership requests (to boxes I own).
 *
 * The path used to read `/ment/cashbox/invited-and-request-list/` — the leading
 * `cashbox_manage` had been sliced off, so this 404'd on every call.
 * `inviteCount` on the messages page was therefore permanently 0 and the
 * «درخواست عضویت» band never appeared: a user invited to a cashbox had no way
 * to learn about it from the PWA.
 */
export const getCashBoxMessages = async () => {
    const { data }: { data: { results: Array<ICashboxDetail> } } =
        await request.get(
            `/cashbox_management/cashbox/invited-and-request-list/`
        )
    return data
}

export const getRequestMessageInPage2 = async (date: string) => {
    const { data }: { data: IRequestMessage } = await request.get(
        `/peripheral/message/request-messages-in-page-v2/${date}/`
    )
    return data
}
